export default "  \n<div class=\"countdown\">\n  <h1>{{text}}</h1>\n  <p>{{timer}}</p>\n</div>";